/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  IconButton,
  Button,
  Alert,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Tooltip,
  Snackbar,
  TextField,
  Typography,
  Grid,
  FormControl,
  Select,
  InputLabel,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { Delete, Edit, Cancel, Check } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CRUDUser from "./components/CRUDUser";
import MenuItem from "@mui/material/MenuItem";
import { darken } from "@mui/material";
import { API_ROUTES, CODE_QUANGNAM } from "../../../utils/constants";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useMaterialUIController, setHomePage } from "context";
import CRUDChangePassword from "./components/CRUDChangePassword";
import colors from "assets/theme/base/colors";
import { MenuProps } from "utils/constants";
import { format } from "date-fns";

function convertFormatDate(date) {
  var d = date.getDate();
  var m = date.getMonth() + 1; //Month from 0 to 11
  var y = date.getFullYear();
  return "" + (d <= 9 ? "0" + d : d) + "/" + (m <= 9 ? "0" + m : m) + "/" + y;
}
const ALLVALUE = { ma: "0", ten: "Tất cả" };

function Users() {
  const _timeOut = useRef();
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [paramsState, setParamsState] = useState({
    nhomnguoidung: ALLVALUE.ma,
  });
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [optionGroup, setOptionGroup] = useState();
  const [dataHuyen, setDataHuyen] = useState([{ code: "ALL", name: "Tất cả" }]);
  const [nhomnguoidung, setNhomnguoidung] = useState(0);

  const handleDelete = async () => {
    try {
      await axiosPrivateInstance.delete("deleteuser/" + selectedRow.id);
      // Remove the selected row from the data
      fetchData(paramsState, pagination);
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleSave = async (values) => {
    try {
      if (action == "Edit") {
        const response = await axiosPrivateInstance.put(
          "updateuser/" + values.id,
          { ...values },
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        tableData[values.rowIndex] = response.data;
        setAlert({
          alert: true,
          message: "Cập nhật thành công!",
          type: "success",
        });
      } else {
        const response = await axiosPrivateInstance.post(
          "register",
          { ...values },
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        tableData.push(response.data);
        setAlert({
          alert: true,
          message: "Thêm mới thành công!",
          type: "success",
        });
      }
      fetchData(paramsState, pagination);
      setValidationErrors({});
      setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      let data = error.response.data;
      if (error && error.response) {
        if (Array.isArray(data)) {
          let value = "";
          value = data?.join(";");
          validErrors = { ...validErrors, another: value };
        } else {
          Object.entries(data).forEach(([key, value]) => {
            let val = "";
            if (Array.isArray(value)) {
              value.map((item) => {
                val += item;
              });
            } else {
              val = value;
            }
            validErrors = { ...validErrors, [key]: val };
          });
        }
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };
  const handleChangepassword = async (values) => {
    try {
      const response = await axiosPrivateInstance.put(
        "changepassword/" + values.username,
        { ...values },
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setAlert({
        alert: true,
        message: "Cập nhật mật khẩu thành công!",
        type: "success",
      });
      setValidationErrors({});
      setModalOpen1(false);
    } catch (error) {
      let validErrors = {};
      if (error && error.response) {
        Object.entries(error.response.data).forEach(([key, value]) => {
          let val = value;
          if (Array.isArray(value)) {
            value.map((item) => {
              val += item;
            });
          } else {
            val = value;
          }
          validErrors = { ...validErrors, [key]: val };
        });
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };
  const fetchData = async ({ nhomnguoidung }, { pageIndex, pageSize }) => {
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        nhomnguoidung: nhomnguoidung == ALLVALUE.ma ? undefined : nhomnguoidung,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.LISTUSER, {
        params: body,
      });
      setRowCount(response.data?.totalRecord);
      setTableData(response.data?.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  const handleChange = (e) => {
    let { value } = e.target;
    setNhomnguoidung(value);
    setParamsState((prev) => ({
      ...prev,
      nhomnguoidung: value,
    }));
  };

  useEffect(() => {
    const fetchDataHuyen = async () => {
      try {
        const response = await axiosPrivateInstance.get(
          API_ROUTES.GETHUYEN + "?tinh=" + CODE_QUANGNAM
        );
        setDataHuyen(response.data);
      } catch (error) {
        setIsError(true);
        return;
      }
    };
    const fetchDataGroup = async () => {
      try {
        const response = await axiosPrivateInstance.get("group");
        setOptionGroup(response.data);
      } catch (error) {
        setIsError(true);
        return;
      }
    };
    fetchDataGroup();
    fetchDataHuyen();
    // fetchData(0);
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "username",
        header: "Tài khoản",
        muiTableBodyCellProps: {
          align: "left",
        },
        size: 110,
      },
      {
        accessorFn: (row) => `${row.first_name} ${row.last_name}`,
        id: "first_name",
        header: "Họ tên",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "address",
        header: "Địa chỉ",
      },
      {
        accessorFn: (row) => {
          if (!row.birth_date) return "";
          return new Date(row.birth_date);
        },
        accessorKey: "birth_date",
        header: "Ngày sinh",
        size: 110,
        sortingFn: "datetime",
        filterFn: "lessThanOrEqualTo",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (!value) return ""; // If date doesn't exist, return empty string
          const date = new Date(value);
          return format(date, "dd/MM/yyyy");
        },
        Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              format="DD/MM/YYYY"
              onChange={(newValue) => {
                column.setFilterValue(newValue);
              }}
              slotProps={{
                textField: {
                  helperText: "Chế độ lọc: =<",
                  sx: { minWidth: "120px" },
                  variant: "standard",
                },
                actionBar: { actions: ["clear", "today"] },
              }}
              value={column.getFilterValue()}
            />
          </LocalizationProvider>
        ),
      },
      {
        accessorKey: "gender",
        header: "Giới tính",
        size: 100,
        Cell: ({ cell }) => {
          let _gioi_tinh = "";
          let gt = cell.getValue();
          if (gt == "M") _gioi_tinh = "Nam";
          else if (gt == "F") _gioi_tinh = "Nữ";
          else _gioi_tinh = "Khác";
          return (
            <MDBox
              ml={-1}
              component="span"
              sx={(theme) => ({
                backgroundColor:
                  cell.getValue() < 50_000
                    ? theme.palette.error.dark
                    : cell.getValue() == "M"
                    ? theme.palette.warning.dark
                    : theme.palette.success.dark,
                borderRadius: "0.25rem",
                color: "#fff",
                maxWidth: "9ch",
                p: "0.25rem",
              })}
            >
              {_gioi_tinh}
            </MDBox>
          );
        },
        Filter: ({ header }) => (
          <TextField
            onChange={(e) =>
              header.column.setFilterValue(e.target.value || undefined)
            }
            select
            value={header.column.getFilterValue() ?? ""}
            margin="none"
            placeholder="Filter"
            variant="standard"
            fullWidth
            sx={{ mt: 1 }}
          >
            <MenuItem value="">Tất cả</MenuItem>
            <MenuItem value="M">Nam</MenuItem>
            <MenuItem value="F">Nữ</MenuItem>
            <MenuItem value="O">Khác</MenuItem>
          </TextField>
        ),
        filterFn: (row, _columnIds, filterValue) =>
          row.getValue("gender").toString() === filterValue,
      },
    ],
    []
  );
  const themeLight = createTheme({
    palette: {
      primary: {
        main: colors.primary.main,
      },
      background: {
        default: colors.background.default,
      },
      info: {
        main: colors.info.main,
      },
    },
  });
  const themeDark = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: colors.error.main,
      },
    },
  });
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const padTo2Digits = (num) => {
    return num.toString().padStart(2, "0");
  };

  const formatDate = (date) => {
    return [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join("-");
  };

  const handelEditClick = async (row) => {
    const username = row.getValue("username");
    try {
      const response = await axiosPrivateInstance.get("getuser/" + username);
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa tài khoản người dùng");
    setValidationErrors({});
    setModalOpen(true);
    setVisible(false);
  };
  const handelChangePasswordClick = async (row) => {
    const username = row.getValue("username");
    try {
      const response = await axiosPrivateInstance.get("getuser/" + username);
      setDataRow({ ...response.data, rowIndex: row.index });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Thay đổi mật khẩu tài khoản người dùng");
    setValidationErrors({});
    setModalOpen1(true);
  };
  useEffect(() => {
    _timeOut.current && clearTimeout(_timeOut.current);
    _timeOut.current = setTimeout(() => {
      fetchData(paramsState, pagination);
    }, [200]);
  }, [paramsState, pagination]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox sx={{ paddingBottom: "20px" }}>
        {alert.alert && (
          <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert.alert}
            onClose={handleCloseAlert}
          >
            <Alert onClose={handleCloseAlert} severity={alert.type}>
              {alert.message}
            </Alert>
          </Snackbar>
        )}
        <Grid
          container
          spacing={2}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={6} lg={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="label-nhom">Nhóm người dùng</InputLabel>
              <Select
                label="Nhóm người dùng"
                sx={{ padding: "0.7rem" }}
                labelId="label-nhom"
                value={nhomnguoidung}
                MenuProps={MenuProps}
                onChange={handleChange}
              >
                <MenuItem value="0">Tất cả</MenuItem>
                {optionGroup &&
                  optionGroup?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <ThemeProvider theme={darkMode ? themeDark : themeLight}>
              <MaterialReactTable
                muiToolbarAlertBannerProps={
                  isError
                    ? {
                        color: "error",
                        children: "Lỗi khi lấy dữ liệu",
                      }
                    : undefined
                }
                columns={columns}
                data={tableData}
                enableFilters={true}
                enableHiding={false}
                enableColumnOrdering={false}
                enableDensityToggle={true}
                enableColumnResizing
                enableGrouping
                muiToolbarAlertBannerChipProps={{ color: "success" }}
                enableEditing
                localization={MRT_Localization_VI}
                positionActionsColumn="last"
                enableRowNumbers
                manualPagination
                onPaginationChange={setPagination}
                rowCount={rowCount}
                rowNumberMode="static"
                renderRowActions={({ row, table }) => (
                  <Box sx={{ display: "flex" }}>
                    <Tooltip arrow placement="left" title="Chỉnh sửa">
                      <IconButton
                        color="info"
                        onClick={() => handelEditClick(row)}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                    <Tooltip arrow placement="left" title="Thay đổi mật khẩu">
                      <IconButton
                        color="warning"
                        onClick={() => handelChangePasswordClick(row)}
                      >
                        <VpnKeyIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip arrow placement="right" title="Xoá">
                      <IconButton
                        color="primary"
                        onClick={() => {
                          let _data = [];
                          _data["id"] = row.getValue("id");
                          _data["ten"] = row.getValue("first_name");
                          handleOpenDeleteConfirmation(_data);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
                renderTopToolbarCustomActions={() => (
                  <Stack spacing={2} direction="row" color="white">
                    <Button
                      color="info"
                      variant="contained"
                      startIcon={<AddIcon />}
                      sx={{ color: "#ffffff" }}
                      onClick={() => {
                        setAction("New");
                        setTitle("Thêm mới người dùng");
                        setDataRow({});
                        setValidationErrors({});
                        setModalOpen(true);
                        setVisible(true);
                      }}
                    >
                      Tạo mới
                    </Button>
                  </Stack>
                )}
                initialState={{
                  expanded: true, //expand all groups by default
                  isLoading: true,
                  columnVisibility: {
                    id: false,
                    address: false,
                  },
                  density: "compact",
                }}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    muiTableHeadCellProps: {
                      align: "center",
                    },
                    muiTableBodyCellProps: {
                      align: "center",
                    },
                    size: 80,
                  },
                }}
                state={{
                  pagination,
                  isLoading,
                  showAlertBanner: isError,
                  showProgressBars: isRefetching,
                }}
                muiTablePaperProps={{
                  elevation: 0,
                  sx: {
                    borderRadius: "0",
                    border: "1px solid rgb(211 225 245)",
                    backgroundColor: "#fff",
                  },
                }}
                muiTableBodyProps={{
                  sx: (theme) => ({
                    "& tr:nth-of-type(odd)": {
                      backgroundColor: darken(
                        theme.palette.background.default,
                        0.1
                      ),
                    },
                  }),
                }}
              />
            </ThemeProvider>
          </Grid>
        </Grid>
        <CRUDUser
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
          visible={visible}
          dataGroup={optionGroup}
          dataHuyen={dataHuyen}
        />
        <CRUDChangePassword
          data={dataRow}
          open={modalOpen1}
          title={title}
          onClose={() => {
            setModalOpen1(false);
            setValidationErrors({});
          }}
          onSubmit={handleChangepassword}
          validationErrors={validationErrors}
          action={action}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá tài khoản: {selectedRow?.ten} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Users;
